module.exports = __webpack_public_path__ + "img/nauru.bd49f0d8.svg";